module.exports = __webpack_public_path__ + "static/media/ru_1.04ebe6a7.gif";


//////////////////
// WEBPACK FOOTER
// ./src/Components/HelpDialogContent/ru_1.gif
// module id = 297
// module chunks = 3